export const PAYMENT_TYPE = {
    CASH_PAYMENT: 'Cash',
    CARD_PAYMENT: 'Card',
    CHEQUE_PAYMENT :'Cheque',
    BANK_DEPOSIT: 'Bank Deposit',
    OVER_PAYMENT :'Over Payment',
    RETURN_AMOUNT :'Return Amount',
    ONLINE_TRANSFER: 'Online Transfer',
    PARTLY_PAID:1,
    FULLY_PAID: 2
   
}